import { Injectable, Input, Directive } from '@angular/core';
import {
  ConfigBaseFilter,
  ConfigService,
  ListLayout,
  ListLayoutMultipleComponent,
  ListSortOption,
  SimpleConfigBaseFilter
} from 'gung-list';
import { CustomerService, GungBase, MetadataService } from 'gung-standard';
import { DeliveryLocationsService, JeevesCustomerDeliveryLocationListConfigService } from 'gung-standard-jeeves';
import { Observable } from 'rxjs';
import { TyloCustomerDeliveryLocationCartListComponent } from '../components/checkout/sweden/tylo-customer-delivery-location-cart-list/tylo-customer-delivery-location-cart-list.component';

export class CustomerSalesPersonFilter extends SimpleConfigBaseFilter<GungBase> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'SALESPERSON';
  }
  getOptionIds(item: GungBase): string[] {
    // return [item.extra.fr.landskod];
    const metadataValue = this.metadataService.getMetadataValue('xr', 'land', item.extra.fr.landskod);
    if (metadataValue == null) {
      return [];
    } else {
      return [metadataValue];
    }
  }

  getOptionName(key: string): string {
    return key;
  }
}

@Directive()
@Injectable({
  providedIn: 'root'
})
export class TyloCustomerDeliveryLocationListConfigService extends JeevesCustomerDeliveryLocationListConfigService {
  @Input()
  customerId: string;

  constructor(
    protected deliveryLocationsService: DeliveryLocationsService,
    protected metadataService: MetadataService
  ) {
    super(deliveryLocationsService, metadataService);
  }

  getLayouts(): ListLayout<GungBase>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => TyloCustomerDeliveryLocationCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Customer list'
      }
    ];
  }
}
